import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WarningIcon from '@mui/icons-material/Warning';

const TrainingLaunchPage = () => {
  // Image de couverture
  const imageUrl = '/assets/rppcub/photo_lanceFormation_rppcub.jpeg';

  // --- 3 PHOTOS DES COMMUNES (remplacez les chemins par vos vraies images) ---
  const imagesCommunes = [
    {
      src: '/assets/rppcub/ngoozi_ouverture.jpg',
      alt: 'Ouverture de la formation à Ngozi - HOPA',
      caption: 'Ngozi – Hôtel Ombre des Patriotes (HOPA)'
    },
    {
      src: '/assets/rppcub/rumonge_ouverture.jpg',
      alt: 'Ouverture de la formation à Rumonge - Galaxy Hotel',
      caption: 'Rumonge – Galaxy Hotel'
    },
    {
      src: '/assets/rppcub/gitega_ouverture.jpg',
      alt: 'Ouverture de la formation à Gitega - Sunset Hotel',
      caption: 'Gitega – Sunset Hotel'
    }
  ];

  return (
    <div style={styles.container}>
      <NavigationBar />
      
      <main style={styles.main}>
        <header style={styles.header}>
          {/* Badges */}
          <div style={styles.badges}>
            <span style={styles.badgeRed}>INSBU</span>
            <span style={styles.badgeGreen}>RPPCUB</span>
            <span style={styles.badgeGray}>Actualité</span>
          </div>

          <h1 style={styles.title}>
            RPPCUB 2026 : C’est parti ! Ngozi, Rumonge et Gitega lancent la formation des agents recenseurs
          </h1>

          <div style={styles.meta}>
            <span style={styles.metaItem}>
              <CalendarTodayIcon style={styles.metaIcon} /> Publié le 28 juillet 2026
            </span>
            <span style={styles.metaItem}>
              <LocationOnIcon style={styles.metaIcon} /> Burundi
            </span>
            <span style={styles.metaItem}>
              <AccessTimeIcon style={styles.metaIcon} /> Lecture 3 min
            </span>
          </div>

          {/* PHOTO DE COUVERTURE */}
          <div style={styles.imageWrapper}>
            <img 
              src={imageUrl} 
              alt="Lancement des formations RPPCUB 2026 à Ngozi, Rumonge et Gitega" 
              style={styles.heroImage}
            />
            <p style={styles.imageCaption}>
              Les candidats présélectionnés suivent avec attention le discours d'ouverture de l'Administrateur communal de RUMONGE
            </p>
          </div>

          {/* Chapeau */}
          <p style={styles.chapeau}>
            Ce mardi 28 juillet 2026, le compte à rebours est officiellement lancé. Les communes de Ngozi, Rumonge et Gitega ont donné le coup d’envoi des sessions de formation du Recensement des Propriétaires des Propriétés/Parcelles dans les centres urbains du Burundi (RPPCUB). Placées sous l’autorité des Administrateurs communaux, ces premières journées marquent l’entrée en scène des futurs acteurs de la modernisation foncière. Les trois autres communes entreront en action dès le 3 août prochain.
          </p>
        </header>

        <article style={styles.article}>
          
          {/* SECTION 1 */}
          <h2 style={styles.h2}>1. Une ouverture sous le signe de l’excellence et de la rigueur</h2>
          <p style={styles.p}>
            Dès 08h00 précises, les salles de formation affichaient complet à l’Hôtel Ombre des Patriotes (Ngozi), au Galaxy Hotel (Rumonge) et au Sunset Hotel (Gitega). Dans une ambiance studieuse, les Administrateurs communaux ont procédé à l'ouverture officielle des travaux, saluant l'assiduité exemplaire des candidats présélectionnés.
          </p>

          {/* === NOUVELLE GALERIE DES 3 PHOTOS (NGOZI, RUMONGE, GITEGA) === */}
          <h3 style={styles.galleryTitle}>📸 En images : l’ouverture dans les trois communes</h3>
          <div style={styles.galleryGrid}>
            {imagesCommunes.map((item, index) => (
              <div key={index} style={styles.galleryItem}>
                <img 
                  src={item.src} 
                  alt={item.alt} 
                  style={styles.galleryImg}
                  onError={(e) => { e.target.src = 'https://placehold.co/300x200/008D36/FFFFFF?text=Photo+disponible'; }}
                />
                <p style={styles.galleryCaption}>{item.caption}</p>
              </div>
            ))}
          </div>

          <p style={styles.p}>
            Dans son allocution, l'Administrateur communal a martelé un message clair : <strong>le RPPCUB n'est pas une simple opération statistique, mais un levier stratégique pour la paix sociale et le développement économique.</strong>
          </p>
          <blockquote style={styles.blockquote}>
            « Les données que vous allez collecter ne sont pas des chiffres froids. Ce sont des vies, des héritages familiaux et l'avenir de nos villes. La délivrance des titres fonciers numériques dépend de la fiabilité de vos enregistrements. »
          </blockquote>

          {/* SECTION 2 */}
          <h2 style={styles.h2}>2. Intégrité et ponctualité : les deux mamelles de la mission</h2>
          <p style={styles.p}>
            L’Administrateur a été sans équivoque sur deux points sensibles :
          </p>
          <ul style={styles.ul}>
            <li style={styles.li}>
              <strong>La tolérance zéro contre la corruption :</strong> <em>« Aucun bakchich, aucun cadeau, aucune faveur. Vous êtes les yeux et la main de l'État. Toute dérive sera sanctionnée par la loi. »</em> Un rappel salutaire qui rassure la population sur la transparence du processus.
            </li>
            <li style={styles.li}>
              <strong>La règle des 08h00 :</strong> Les montres ont été mises à l’heure. <em>« Un retard, c’est un désistement »</em>, a-t-on répété en chœur. Une discipline de fer indispensable pour boucler les formations dans les délais impartis.
            </li>
          </ul>

          {/* SECTION 3 */}
          <h2 style={styles.h2}>3. Le calendrier complet et les sites à retenir</h2>
          <p style={styles.p}>
            Pour ne laisser personne dans l'incertitude, voici la répartition géographique validée par l'INSBU :
          </p>

          <div style={styles.infoBlock}>
            <p style={styles.p}>
              <strong>Phase 1 (28 au 31 juillet) :</strong> Ngozi (HOPA), Rumonge (Galaxy Hotel), Gitega (Sunset Hotel).
            </p>
            <p style={styles.p}>
              <strong>Phase 2 (3 au 6/7 août) :</strong> Ntahangwa (Espace Isaganirizo), Mugere (Tiger's Appartement) et Mukaza (CEPRODILIC).
            </p>
            <p style={styles.p}>
              <strong>Chefs d’équipes :</strong> Des sessions spécialisées sont prévues les 1er, 7 et 8 août pour encadrer la collecte.
            </p>
          </div>

          <div style={styles.lieuxBox}>
            <p style={styles.lieuxTitle}>
              <LocationOnIcon style={styles.lieuxIcon} /> Détail des lieux de formation
            </p>
            <ul style={styles.lieuxList}>
              <li style={styles.lieuxItem}><strong>Ngozi</strong> – Hôtel Ombre des Patriotes (HOPA)</li>
              <li style={styles.lieuxItem}><strong>Rumonge</strong> – Galaxy Hotel</li>
              <li style={styles.lieuxItem}><strong>Gitega</strong> – Sunset Hotel</li>
              <li style={styles.lieuxItem}>
                <strong>Ntahangwa</strong> – Espace Isaganirizo (ESIS) – situé près du bureau communal à environ 300 m, sur la RN en direction de Gihanga.
              </li>
              <li style={styles.lieuxItem}><strong>Mugere</strong> – Tiger's Appartement</li>
              <li style={styles.lieuxItem}><strong>Mukaza</strong> – CEPRODILIC</li>
            </ul>
          </div>

          {/* SECTION 4 */}
          <h2 style={styles.h2}>4. Un appel à la conscience professionnelle</h2>
          <p style={styles.p}>
            Au-delà du simple geste technique, les agents recenseurs ont été investis d'une véritable mission républicaine. L’Administrateur leur a demandé de faire preuve de <em>« courtoisie, de patience et d'impartialité »</em>. Sur le terrain, ils croiseront des Nyumbakumi, des chefs de quartiers et des services communaux prêts à les épauler.
          </p>
          <div style={styles.attentionBox}>
            <WarningIcon style={styles.attentionIcon} />
            <p style={styles.attentionText}>
              En cas de difficulté ou de tentative d'intimidation, la consigne est formelle : <strong>« Ne restez jamais isolés. Remontez l'information à votre chef d'équipe ou à l'administration locale. Nous sommes votre rempart. »</strong>
            </p>
          </div>

          <div style={styles.conclusion}>
            <p style={styles.p}>
              Avec cette montée en puissance, le Burundi pose un jalon décisif vers la sécurisation foncière. Les agents recenseurs, désormais en première ligne, portent sur leurs épaules l'espoir d'une administration moderne et transparente. Rendez-vous le 3 août pour la seconde vague de formations à Bujumbura !
            </p>
            <p style={styles.vive}>
              <strong>Vive le RPPCUB, vive le Burundi !</strong>
            </p>
          </div>

          <div style={styles.signature}>
            <p>— Publié par l'INSBU —</p>
          </div>

        </article>
      </main>

      <Footer />
    </div>
  );
};

// ================= STYLES =================
const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '820px',
    margin: '0 auto',
    padding: '40px 20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingBottom: '30px',
    borderBottom: '2px solid #e0e0e0',
  },
  badges: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  badgeRed: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGreen: {
    backgroundColor: '#008D36',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGray: {
    backgroundColor: '#6c757d',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  title: {
    color: '#1a1a1a',
    fontSize: '2.4rem',
    fontWeight: '700',
    lineHeight: 1.2,
    marginBottom: '12px',
    letterSpacing: '-0.3px',
  },
  meta: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    marginBottom: '20px',
    fontSize: '0.9rem',
    color: '#6c757d',
  },
  metaItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  metaIcon: {
    fontSize: '1rem',
    color: '#008D36',
  },
  imageWrapper: {
    marginBottom: '24px',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  heroImage: {
    width: '100%',
    height: 'auto',
    maxHeight: '420px',
    objectFit: 'cover',
    display: 'block',
    borderRadius: '8px 8px 0 0',
  },
  imageCaption: {
    fontSize: '0.85rem',
    color: '#6c757d',
    textAlign: 'center',
    padding: '8px 0 4px 0',
    fontStyle: 'italic',
    backgroundColor: '#fafafa',
    margin: 0,
    borderBottom: '1px solid #eaeaea',
    borderRadius: '0 0 8px 8px',
  },
  chapeau: {
    fontSize: '1.2rem',
    lineHeight: 1.7,
    color: '#2c3e50',
    maxWidth: '700px',
    margin: '0 auto',
    fontWeight: '400',
    borderLeft: '4px solid #008D36',
    paddingLeft: '20px',
    textAlign: 'left',
  },
  article: {
    backgroundColor: 'white',
    padding: '40px 45px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
    marginBottom: '40px',
  },
  h2: {
    color: '#008D36',
    fontSize: '1.5rem',
    fontWeight: '600',
    marginTop: '40px',
    marginBottom: '16px',
    paddingBottom: '6px',
    borderBottom: '2px solid #eaeaea',
  },
  p: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#1e1e1e',
    marginBottom: '20px',
    textAlign: 'justify',
  },
  blockquote: {
    fontSize: '1.1rem',
    lineHeight: 1.7,
    color: '#1a3a2a',
    backgroundColor: '#f0f7f4',
    padding: '16px 24px',
    borderRadius: '8px',
    borderLeft: '4px solid #008D36',
    margin: '0 0 20px 0',
    fontStyle: 'italic',
  },
  ul: {
    paddingLeft: '20px',
    marginBottom: '20px',
  },
  li: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#1e1e1e',
    marginBottom: '10px',
  },
  infoBlock: {
    backgroundColor: '#f8fafc',
    padding: '20px 25px',
    borderRadius: '8px',
    borderLeft: '4px solid #008D36',
    marginBottom: '25px',
  },
  lieuxBox: {
    backgroundColor: '#f0f7f4',
    padding: '20px 25px',
    borderRadius: '8px',
    border: '1px solid #d0e6dc',
    marginBottom: '30px',
  },
  lieuxTitle: {
    fontWeight: '700',
    fontSize: '1.05rem',
    color: '#008D36',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  lieuxIcon: {
    fontSize: '1.3rem',
    color: '#008D36',
  },
  lieuxList: {
    listStyle: 'none',
    padding: 0,
    margin: '8px 0 0 0',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: '6px 20px',
  },
  lieuxItem: {
    fontSize: '0.95rem',
    lineHeight: 1.6,
    color: '#1e1e1e',
  },
  attentionBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    backgroundColor: '#fef3f2',
    padding: '18px 22px',
    borderRadius: '8px',
    border: '1px solid #f5c6cb',
    marginBottom: '30px',
  },
  attentionIcon: {
    fontSize: '1.6rem',
    color: '#E30613',
    flexShrink: 0,
    marginTop: '2px',
  },
  attentionText: {
    margin: 0,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: '#721c24',
  },
  conclusion: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '1px solid #eaeaea',
  },
  vive: {
    fontSize: '1.3rem',
    fontWeight: '700',
    color: '#008D36',
    textAlign: 'center',
    marginTop: '20px',
    letterSpacing: '0.5px',
  },
  signature: {
    textAlign: 'center',
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '1px solid #eaeaea',
    color: '#6c757d',
    fontSize: '0.9rem',
    letterSpacing: '0.3px',
  },

  // ===== NOUVEAUX STYLES POUR LA GALERIE DES 3 COMMUNES =====
  galleryTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#008D36',
    marginTop: '10px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  galleryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
    marginBottom: '25px',
  },
  galleryItem: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    border: '1px solid #eaeaea',
  },
  galleryImg: {
    width: '100%',
    height: '170px',
    objectFit: 'cover',
    display: 'block',
  },
  galleryCaption: {
    padding: '8px 10px',
    fontSize: '0.75rem',
    textAlign: 'center',
    color: '#2c3e50',
    fontWeight: 600,
    backgroundColor: '#fafafa',
    margin: 0,
    borderTop: '1px solid #eaeaea',
  },
};

export default TrainingLaunchPage;